import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  constructor(private api: ApiService) { }

  getAccountFields(data: any): Observable<any> {
    return this.api.post(environment.getAccountFields, data);
  }

  createAccountField(data: any): Observable<any> {
    return this.api.post(environment.createAccountField, data);
  }

  deleteAccountField(data: any): Observable<any> {
    return this.api.post(environment.deleteAccountField, data);
  }

  updateAccountField(data: any): Observable<any> {
    return this.api.post(environment.updateAccountField, data);
  }

  
  
}

